import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';

export const styles = theme => ({
  boxLevel: {
    border: `1px solid ${theme.palette.line.main}`,
    '&:nth-of-type(even)': {
      borderRight: '0px solid #ccc',
      borderLeft: '0px solid #ccc',
    },
  },
  title: {
    textAlign: 'center',
    fontSize: '9px',
    fontFamily: theme.typography.fontKanit,
  },
  titleSub: {
    fontFamily: theme.typography.fontKanit,
    fontSize: 14,
    fontWeight: 500,
  },
});

export const LegendTableCell = withStyles(theme => ({
  root: {
    color: theme.palette.grey.main,
    border: '1px solid #ccc',
  },
  head: {
    '&:nth-of-type(1)': {
      textAlign: 'left',
    },
    backgroundColor: theme.palette.grey.main,
    fontWeight: 400,
    fontSize: '0.8rem',
    height: theme.spacing(1),
    textAlign: 'center',
    fontFamily: 'Kanit',
  },
  body: {
    '&:nth-of-type(1)': {
      textAlign: 'left',
    },
    color: theme.palette.grey.main,
    height: theme.spacing(2),
    whiteSpace: 'nowrap',
    fontSize: '0.7rem',
    textAlign: 'center',
  },
  footer: {
    color: theme.palette.grey.main,
    fontWeight: 500,
    fontSize: '1rem',
    height: theme.spacing(2),
    borderBottom: '2px solid #999',
  },

}))(TableCell);